(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-ui/tv/assets/javascripts/shared.js') >= 0) return;  svs.modules.push('/components/lb-ui/tv/assets/javascripts/shared.js'); "use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }


var svs = svs || {};

(function (svs) {
  'use strict';

  var isServerSide = (typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object',
      config;

  if (isServerSide) {
    var trinidad = require('trinidad-core').core;

    config = trinidad.config;
  } else {
    config = {
      options: svs.core.config.data.svsconfig
    };
  }

  svs.lb_ui = svs.lb_ui || {};
  svs.lb_ui.tv = svs.lb_ui.tv || {};
  var path = '/images/lb-ui/tv/',
      hashedFiles = {
    'kanal8': 'kanal8-64-806877a9dd34852593cf2fbe1bc2e4c4b2b5b133.png',
    'kanal8-16': 'kanal8-16-0407101c4632ebcf0c4d4cd03fcd4354d9e70ea4.png',
    'kanal8-32': 'kanal8-32-b83a2086b1df49128d31e8ff0daaae045d543723.png',
    'kanal8-64': 'kanal8-64-806877a9dd34852593cf2fbe1bc2e4c4b2b5b133.png',
    'cmore': 'cmore-64-ba45fc5a715ca5621c6e2a396996588a12a6f56c.png',
    'cmore-16': 'cmore-16-c34ecc0b547b7c44bd0bc0004c674260443c957e.png',
    'cmore-32': 'cmore-32-0940a13195517c3e9438e203a428ce26d243eb65.png',
    'cmore-64': 'cmore-64-ba45fc5a715ca5621c6e2a396996588a12a6f56c.png',
    'cmorefirsthd': 'cmorefirsthd-64-ca46db9885f61489eace72b921a4ae73fe09d580.png',
    'cmorefirsthd-16': 'cmorefirsthd-16-aa3f4a10b96390ecf0a652c2a275510a33cbb2aa.png',
    'cmorefirsthd-32': 'cmorefirsthd-32-da40c2600a5e8773e3629bac657c91c4cbb4e2b7.png',
    'cmorefirsthd-64': 'cmorefirsthd-64-ca46db9885f61489eace72b921a4ae73fe09d580.png',
    'cmorefotboll': 'cmorefotboll-64-4e9ebbbfb3f4f231cc69dc59fb8d4d86dfb96cc1.png',
    'cmorefotboll-16': 'cmorefotboll-16-9dbbd25042d2879fa87c1e92f5aa79a053121b99.png',
    'cmorefotboll-32': 'cmorefotboll-32-3397a76b73a8626cf24bc7e7380be88d49d0e34f.png',
    'cmorefotboll-64': 'cmorefotboll-64-4e9ebbbfb3f4f231cc69dc59fb8d4d86dfb96cc1.png',
    'cmorefotbollhd': 'cmorefotbollhd-64-3ee0b20982a9c3b523166155013a3e22b1e6398c.png',
    'cmorefotbollhd-16': 'cmorefotbollhd-16-f8a3e7a07f2b7b3357633ceadbd324ec3e4b8535.png',
    'cmorefotbollhd-32': 'cmorefotbollhd-32-3d8af13cc84b26deb67ea4e395e965842785a44d.png',
    'cmorefotbollhd-64': 'cmorefotbollhd-64-3ee0b20982a9c3b523166155013a3e22b1e6398c.png',
    'cmoregolf': 'cmoregolf-64-0dd392f972aed2cfe06163ddace4c463252e1058.png',
    'cmoregolf-16': 'cmoregolf-16-0a8171e47d79e945c7a803c43d992e685fbfcca7.png',
    'cmoregolf-32': 'cmoregolf-32-8ab230bb0b8adc21b5657c4cf552a3affe076537.png',
    'cmoregolf-64': 'cmoregolf-64-0dd392f972aed2cfe06163ddace4c463252e1058.png',
    'cmoregolfhd': 'cmoregolfhd-64-c5de839e26d5f50295fc5d332aefe6434101658e.png',
    'cmoregolfhd-16': 'cmoregolfhd-16-73f70ea37a16f88b815482e81737bb6f9d028af1.png',
    'cmoregolfhd-32': 'cmoregolfhd-32-60c7c1106410698c3e53462a7eca76e0b9ac46c9.png',
    'cmoregolfhd-64': 'cmoregolfhd-64-c5de839e26d5f50295fc5d332aefe6434101658e.png',
    'cmorehockey': 'cmorehockey-64-0d00e7a2b58c5215941f98be77eb5bbd41c65110.png',
    'cmorehockey-16': 'cmorehockey-16-9bba07d64202c7d56538f747f4ee0dd682ba2463.png',
    'cmorehockey-32': 'cmorehockey-32-7f410efde65f804b704174f2ffe2de42b86cd878.png',
    'cmorehockey-64': 'cmorehockey-64-0d00e7a2b58c5215941f98be77eb5bbd41c65110.png',
    'cmorehockeyhd': 'cmorehockeyhd-64-4841c7355c747658ab8a0199ea8d739879f35549.png',
    'cmorehockeyhd-16': 'cmorehockeyhd-16-e5e0f8e3bca8681df49505494e4166a3beabecb8.png',
    'cmorehockeyhd-32': 'cmorehockeyhd-32-df153aca2d5c6bb0e3022b41ac8b3f650e4eb4b2.png',
    'cmorehockeyhd-64': 'cmorehockeyhd-64-4841c7355c747658ab8a0199ea8d739879f35549.png',
    'cmorelive': 'cmorelive-64-d42c79d84854f06c62a8cda6228706b0ce4c5b48.png',
    'cmorelive-16': 'cmorelive-16-27d473f91050139fb10bed1238fc92121ba85f03.png',
    'cmorelive-32': 'cmorelive-32-4e890d1669c1058a795283542bd912360569e8e6.png',
    'cmorelive-64': 'cmorelive-64-d42c79d84854f06c62a8cda6228706b0ce4c5b48.png',
    'cmorelive2': 'cmorelive2-64-5e32a6ec9dcd0332372041e0ac965362704c16d7.png',
    'cmorelive2-16': 'cmorelive2-16-18e8318e57742652539d00bb59bd222e9eb11493.png',
    'cmorelive2-32': 'cmorelive2-32-e70d36b82de585b64d41eb54111f66cb7e770e5b.png',
    'cmorelive2-64': 'cmorelive2-64-5e32a6ec9dcd0332372041e0ac965362704c16d7.png',
    'cmorelive2hd': 'cmorelive2hd-64-25a8161ce417cd4d0b14bfbe8d634c290ad4b8a8.png',
    'cmorelive2hd-16': 'cmorelive2hd-16-34c9c1e0491a22e471d8cd2496e11d51e6cee2db.png',
    'cmorelive2hd-32': 'cmorelive2hd-32-4b484133d1df746940e6f15b52876dcced3c76b7.png',
    'cmorelive2hd-64': 'cmorelive2hd-64-25a8161ce417cd4d0b14bfbe8d634c290ad4b8a8.png',
    'cmorelive3': 'cmorelive3-64-6a754d0319c690d912cd33826d6eac2d4e590cc0.png',
    'cmorelive3-16': 'cmorelive3-16-43cdc19851be9367763b97629f853fe07488ecb7.png',
    'cmorelive3-32': 'cmorelive3-32-2c1fab4ddd21a62566726ebf161bf3a9f67890cd.png',
    'cmorelive3-64': 'cmorelive3-64-6a754d0319c690d912cd33826d6eac2d4e590cc0.png',
    'cmorelive3hd': 'cmorelive3hd-64-5c80a40dfa76e093f48c846da8d96cabb6dbe834.png',
    'cmorelive3hd-16': 'cmorelive3hd-16-eec70743cbb9adf2ddc2d2df97e598c157a45319.png',
    'cmorelive3hd-32': 'cmorelive3hd-32-2274a416400260a8ec4d859c436c8b54f39f9faa.png',
    'cmorelive3hd-64': 'cmorelive3hd-64-5c80a40dfa76e093f48c846da8d96cabb6dbe834.png',
    'cmorelive4': 'cmorelive4-64-d43827a579f8ae90cf50664ebb36e9bde890ce22.png',
    'cmorelive4-16': 'cmorelive4-16-5c0591383aea8661fedaa0e772d7adb284831fe4.png',
    'cmorelive4-32': 'cmorelive4-32-4ef52ddaf28aa17e2e5d34e4243fb46d4021d653.png',
    'cmorelive4-64': 'cmorelive4-64-d43827a579f8ae90cf50664ebb36e9bde890ce22.png',
    'cmorelive4hd': 'cmorelive4hd-64-2b19a7e9aa208b53d8e6ce3b7cfe1053207c7bac.png',
    'cmorelive4hd-16': 'cmorelive4hd-16-3d25000e75546fb38f7770e28c877240d357bd98.png',
    'cmorelive4hd-32': 'cmorelive4hd-32-80491bd3399be773b3141b506cb6ec25da7904a1.png',
    'cmorelive4hd-64': 'cmorelive4hd-64-2b19a7e9aa208b53d8e6ce3b7cfe1053207c7bac.png',
    'cmorelive5': 'cmorelive5-64-fa4752fa2e89ddaaf0857cd8599b71b067c69705.png',
    'cmorelive5-16': 'cmorelive5-16-01d0b94bd7058cb74f666e35368a0f5515e1b6ce.png',
    'cmorelive5-32': 'cmorelive5-32-4e95dd1df5ab274332536d1e3f6eca8e8b678215.png',
    'cmorelive5-64': 'cmorelive5-64-fa4752fa2e89ddaaf0857cd8599b71b067c69705.png',
    'cmorelive5hd': 'cmorelive5hd-64-0d4e6cf981c7c5bc2c7d434afe3390b38a2fa4fa.png',
    'cmorelive5hd-16': 'cmorelive5hd-16-c04fb7c4205d2bde255f3a24fd313319c8bd591e.png',
    'cmorelive5hd-32': 'cmorelive5hd-32-341798767454370ae73e1fd85e5a069885026313.png',
    'cmorelive5hd-64': 'cmorelive5hd-64-0d4e6cf981c7c5bc2c7d434afe3390b38a2fa4fa.png',
    'cmorelivehd': 'cmorelivehd-64-73a9158abc89261ac8cff9a053d4a9e188f08a91.png',
    'cmorelivehd-16': 'cmorelivehd-16-25db29f27bf116e7db38d42b85c4fc1f8764e90e.png',
    'cmorelivehd-32': 'cmorelivehd-32-acdb16f9db017036f845022c8b575afe03e0c275.png',
    'cmorelivehd-64': 'cmorelivehd-64-73a9158abc89261ac8cff9a053d4a9e188f08a91.png',
    'cmoresport': 'cmoresport-64-81ef5a5bdbdd4b774fa6464dfac088956139f2c3.png',
    'cmoresport-16': 'cmoresport-16-ad6b927ea15e4f1e99168979056b17393c97f3fc.png',
    'cmoresport-32': 'cmoresport-32-9afc8a93948c67458bf7dceda79f469a597cb6c2.png',
    'cmoresport-64': 'cmoresport-64-81ef5a5bdbdd4b774fa6464dfac088956139f2c3.png',
    'cmoresporthd': 'cmoresporthd-64-e048b03f43d52cb72f3817db4c7711c8c074fa63.png',
    'cmoresporthd-16': 'cmoresporthd-16-4c8cebc5e399721ba9fc1ba1631bedd22e51d8b0.png',
    'cmoresporthd-32': 'cmoresporthd-32-bdd33952fb172dcb4c2bdd945cc70db9693581b6.png',
    'cmoresporthd-64': 'cmoresporthd-64-e048b03f43d52cb72f3817db4c7711c8c074fa63.png',
    'cmoresportstream': 'cmoresportstream-64-ba45fc5a715ca5621c6e2a396996588a12a6f56c.png',
    'cmoresportstream-16': 'cmoresportstream-16-c34ecc0b547b7c44bd0bc0004c674260443c957e.png',
    'cmoresportstream-32': 'cmoresportstream-32-0940a13195517c3e9438e203a428ce26d243eb65.png',
    'cmoresportstream-64': 'cmoresportstream-64-ba45fc5a715ca5621c6e2a396996588a12a6f56c.png',
    'cmorestream': 'cmorestream-64-ba45fc5a715ca5621c6e2a396996588a12a6f56c.png',
    'cmorestream-16': 'cmorestream-16-c34ecc0b547b7c44bd0bc0004c674260443c957e.png',
    'cmorestream-32': 'cmorestream-32-0940a13195517c3e9438e203a428ce26d243eb65.png',
    'cmorestream-64': 'cmorestream-64-ba45fc5a715ca5621c6e2a396996588a12a6f56c.png',
    'cmoretennis': 'cmoretennis-64-f913ccfb1736f7a868a03d096896b74f706f1f1f.png',
    'cmoretennis-16': 'cmoretennis-16-16ea03d18b15a6900d88db5117a19926e73342aa.png',
    'cmoretennis-32': 'cmoretennis-32-458f6b722b68c7c2b0ab05e85f487e67759a2b51.png',
    'cmoretennis-64': 'cmoretennis-64-f913ccfb1736f7a868a03d096896b74f706f1f1f.png',
    'cmoretennishd': 'cmoretennishd-64-3cb52411f1ef62d99d2993afe58c15f4c1b00516.png',
    'cmoretennishd-16': 'cmoretennishd-16-d4784b02090877dc6d6920f44b1435e7d7abd31b.png',
    'cmoretennishd-32': 'cmoretennishd-32-3f13bbec7d19cfdd0609834a40858b5328dba768.png',
    'cmoretennishd-64': 'cmoretennishd-64-3cb52411f1ef62d99d2993afe58c15f4c1b00516.png',
    'espn': 'espn-64-0688f7cb5f38097328d51e6db6149e270c372f47.png',
    'espn-16': 'espn-16-7f8a642e2a397986370d72a1cf0bf9f7c6295a84.png',
    'espn-32': 'espn-32-7f24a6f9d2c6753f7badeec8d36fecf7c68ad0ce.png',
    'espn-64': 'espn-64-0688f7cb5f38097328d51e6db6149e270c372f47.png',
    'espnamerica': 'espnamerica-64-5102efe5d0ed2daf057f4f5d2e17b7cd9e72afcf.png',
    'espnamerica-16': 'espnamerica-16-e4b5b5dbd17ea80f7ed9cf5fed6858bef5845cbe.png',
    'espnamerica-32': 'espnamerica-32-c1cd57770887d764de4ce45358b6632e7e604807.png',
    'espnamerica-64': 'espnamerica-64-5102efe5d0ed2daf057f4f5d2e17b7cd9e72afcf.png',
    'espnamericahd': 'espnamericahd-64-89b3e62b4e8f27dff15f9b19fac52ad945c6f40e.png',
    'espnamericahd-16': 'espnamericahd-16-6989b07d25c8fb8a5bfb2892c3edcf3a4b4f26ff.png',
    'espnamericahd-32': 'espnamericahd-32-a995f5d7b6236e7d24365540a43a1b7a16b58ea2.png',
    'espnamericahd-64': 'espnamericahd-64-89b3e62b4e8f27dff15f9b19fac52ad945c6f40e.png',
    'eurosport': 'eurosport-64-f888fa0694f4f7bf8d414d1e22c667c99605f2ea.png',
    'eurosport-16': 'eurosport-16-2629a70c963b88aae5b591e04a9066f4d3ce3eab.png',
    'eurosport-32': 'eurosport-32-c71e2abf18f29f47b18e23e4e5360574dc2db8f0.png',
    'eurosport-64': 'eurosport-64-f888fa0694f4f7bf8d414d1e22c667c99605f2ea.png',
    'eurosport1': 'eurosport1-64-75a8c612db7fa15df3a93e5d77285be3aa111dac.png',
    'eurosport1-16': 'eurosport1-16-d0c623b5d9ae70117e1e8bf8d488ac37e6c4f063.png',
    'eurosport1-32': 'eurosport1-32-a46d4e3cb10e338d2ad4fef26d6d5808fe56019f.png',
    'eurosport1-64': 'eurosport1-64-75a8c612db7fa15df3a93e5d77285be3aa111dac.png',
    'eurosport1hd': 'eurosport1hd-64-5ae6700ab6df60a7ef24dd309d83e70ac8ac6d61.png',
    'eurosport1hd-16': 'eurosport1hd-16-1078f444493a6a495be3e605cf0f815756de6008.png',
    'eurosport1hd-32': 'eurosport1hd-32-fc950c44269f82bced72bcf0709776d8f41b91e2.png',
    'eurosport1hd-64': 'eurosport1hd-64-5ae6700ab6df60a7ef24dd309d83e70ac8ac6d61.png',
    'eurosport2': 'eurosport2-64-4bee98ff00e53125547807c23c2b585feaa8210c.png',
    'eurosport2-16': 'eurosport2-16-aed39f472be050e8befcea3a52d9f01f42776af3.png',
    'eurosport2-32': 'eurosport2-32-f3a3867ccef5dc68a3674d9b631b71056065ac76.png',
    'eurosport2-64': 'eurosport2-64-4bee98ff00e53125547807c23c2b585feaa8210c.png',
    'eurosport2hd': 'eurosport2hd-64-c79e4a505ee83e78162f78f15b559b83a7dedae4.png',
    'eurosport2hd-16': 'eurosport2hd-16-7b23bcf4a61bf8c9060e847e97fc40aeeb4d8fe2.png',
    'eurosport2hd-32': 'eurosport2hd-32-2e7dd161fcf48d37f13e8bb67040a1a266b47e3b.png',
    'eurosport2hd-64': 'eurosport2hd-64-c79e4a505ee83e78162f78f15b559b83a7dedae4.png',
    'fotbollskanalen': 'fotbollskanalen-64-4759a24da592fe75edd0b7e8fa45a3f4a741bdf8.png',
    'fotbollskanalen-16': 'fotbollskanalen-16-98c55ea9fadc768a25fdefa59825f011afcd5c1e.png',
    'fotbollskanalen-32': 'fotbollskanalen-32-21695829ffee31b8e817e944e3781a93e5a125b1.png',
    'fotbollskanalen-64': 'fotbollskanalen-64-4759a24da592fe75edd0b7e8fa45a3f4a741bdf8.png',
    'kanal11': 'kanal11-64-6b0a3571878b52e8073de4def1791050d1e95115.png',
    'kanal11-16': 'kanal11-16-2be29be3a64d05aca71f0bc50e0b884f39fb7e17.png',
    'kanal11-32': 'kanal11-32-707d73035979d18d4656ec4c7318f2b35c48ead1.png',
    'kanal11-64': 'kanal11-64-6b0a3571878b52e8073de4def1791050d1e95115.png',
    'kanal5': 'kanal5-64-c15234e6e97087858241e645cc1d7e599a532206.png',
    'kanal5-16': 'kanal5-16-eb8fdf51d6947c086bacf271bda98d3dad58a835.png',
    'kanal5-32': 'kanal5-32-a2d1168e53a330a068a64f4f27ba8681a59b8c78.png',
    'kanal5-64': 'kanal5-64-c15234e6e97087858241e645cc1d7e599a532206.png',
    'kanal7': 'kanal7-64-5df03b62f3cba572aeac05ff0466e4fad5ac5772.png',
    'kanal7-16': 'kanal7-16-b60755b971a28af106774ee0d789fe0f790e2c23.png',
    'kanal7-32': 'kanal7-32-fe121449d965afa104a0090e10ebb74568cd520b.png',
    'kanal7-64': 'kanal7-64-5df03b62f3cba572aeac05ff0466e4fad5ac5772.png',
    'cmorefirst': 'cmorefirst-64-a60aa6dcd642977c4f59b9e8f68699ed93a4f9e9.png',
    'cmorefirst-16': 'cmorefirst-16-071bb9f9885c27cabe19332e6d9340bd9c313559.png',
    'cmorefirst-32': 'cmorefirst-32-e17623c7d789f0b683f654e3e2f8c5f092729ff4.png',
    'cmorefirst-64': 'cmorefirst-64-a60aa6dcd642977c4f59b9e8f68699ed93a4f9e9.png',
    'kanal9': 'kanal9-64-c6801a913c8c91771bdea4bc29969afedeb4b4ce.png',
    'kanal9-16': 'kanal9-16-c3cf66ac2b04348b765e3cc65fb1937ee58483d6.png',
    'kanal9-32': 'kanal9-32-16d62f12cc35d8492bb36d71ef995238c0a8581e.png',
    'kanal9-64': 'kanal9-64-c6801a913c8c91771bdea4bc29969afedeb4b4ce.png',
    'kunskapskanalen': 'kunskapskanalen-64-8984b0ead131210c8128114fe934d33be9298b27.png',
    'kunskapskanalen-16': 'kunskapskanalen-16-5b62914b85067be1c60a8cc657e8fc60d9f09e87.png',
    'kunskapskanalen-32': 'kunskapskanalen-32-2b187691e1b9b5e2045d772fc13155cf212394ec.png',
    'kunskapskanalen-64': 'kunskapskanalen-64-8984b0ead131210c8128114fe934d33be9298b27.png',
    'livearena': 'livearena-64-162ca509d96c7551f5798d11aa01b6ac20946693.png',
    'livearena-16': 'livearena-16-d2d1a6dde1fd17f6a7a5669abfe18d15c803a508.png',
    'livearena-32': 'livearena-32-61de56980eba61d6ea698f95d3c64a07d97981ea.png',
    'livearena-64': 'livearena-64-162ca509d96c7551f5798d11aa01b6ac20946693.png',
    'sjuan': 'sjuan-64-5df03b62f3cba572aeac05ff0466e4fad5ac5772.png',
    'sjuan-16': 'sjuan-16-b60755b971a28af106774ee0d789fe0f790e2c23.png',
    'sjuan-32': 'sjuan-32-fe121449d965afa104a0090e10ebb74568cd520b.png',
    'sjuan-64': 'sjuan-64-5df03b62f3cba572aeac05ff0466e4fad5ac5772.png',
    'sportkanalen': 'sportkanalen-64-c7f4fe6eaea3d017889d5204d14fbc4deee85bc6.png',
    'sportkanalen-16': 'sportkanalen-16-716d72d2ca6751d4f4aa04e3b6b281b88448ff42.png',
    'sportkanalen-32': 'sportkanalen-32-c09d0fe9300dbfb1c2f346235965657467176e68.png',
    'sportkanalen-64': 'sportkanalen-64-c7f4fe6eaea3d017889d5204d14fbc4deee85bc6.png',
    'sportkanalenhd': 'sportkanalenhd-64-78830300da6926668f801ea57042c369261aca3f.png',
    'sportkanalenhd-16': 'sportkanalenhd-16-a59846ef2d56ca8ad660d450728699fdcd3d69dd.png',
    'sportkanalenhd-32': 'sportkanalenhd-32-0f13b7bce719e29b4a975d6569951c2abae37de5.png',
    'sportkanalenhd-64': 'sportkanalenhd-64-78830300da6926668f801ea57042c369261aca3f.png',
    'strive': 'strive-64-a2c69bcea7fef06a36b0138157e2baa6d61a0ff8.png',
    'strive-16': 'strive-16-bdfad9e631fc129dacc5fbc515c4b8a33b75f514.png',
    'strive-32': 'strive-32-018b4bbed2156a8ea424f39403a7896b911d019a.png',
    'strive-64': 'strive-64-a2c69bcea7fef06a36b0138157e2baa6d61a0ff8.png',
    'svt-play': 'svt-play-64-da36c9a5952ea5d1eeeeb228829160468670e121.png',
    'svt-play-16': 'svt-play-16-5904a7f218643449785a4852d05081b6c90dc503.png',
    'svt-play-32': 'svt-play-32-d75934e275b29cbb3a6cb5701cc2301e5ea8d115.png',
    'svt-play-64': 'svt-play-64-da36c9a5952ea5d1eeeeb228829160468670e121.png',
    'svt1': 'svt1-64-4c1a683f7390ed6ccb472029c1cdd5de04c8d7d8.png',
    'svt1-16': 'svt1-16-88a349626549f24c076e42c6d7fc1386d8639e50.png',
    'svt1-32': 'svt1-32-cc39d77df50056047cbb2fb98f66f3d7c3568e8c.png',
    'svt1-64': 'svt1-64-4c1a683f7390ed6ccb472029c1cdd5de04c8d7d8.png',
    'svt2': 'svt2-64-eb8c2c2807e59aef99473ba7fc09909765142ea2.png',
    'svt2-16': 'svt2-16-8dd2a2faf553edd4332411813302d4221a78d510.png',
    'svt2-32': 'svt2-32-a0c90170df7842561f145d2a0ee568c9cf79982d.png',
    'svt2-64': 'svt2-64-eb8c2c2807e59aef99473ba7fc09909765142ea2.png',
    'svt24': 'svt24-64-5aa853719f52e389433085c73b4f2a8104eafd30.png',
    'svt24-16': 'svt24-16-bb9f2eced3b1a6e34fce83bfd872a6c40ee8f082.png',
    'svt24-32': 'svt24-32-e0c6beb7b5413b099f63998547d7ab844cf5fcb9.png',
    'svt24-64': 'svt24-64-5aa853719f52e389433085c73b4f2a8104eafd30.png',
    'svt24hd': 'svt24hd-64-5aa853719f52e389433085c73b4f2a8104eafd30.png',
    'svt24hd-16': 'svt24hd-16-bb9f2eced3b1a6e34fce83bfd872a6c40ee8f082.png',
    'svt24hd-32': 'svt24hd-32-e0c6beb7b5413b099f63998547d7ab844cf5fcb9.png',
    'svt24hd-64': 'svt24hd-64-5aa853719f52e389433085c73b4f2a8104eafd30.png',
    'sydsvenskan': 'sydsvenskan-64-0ce87e2a6e6608831b57e5b7ff1b46530bd9603b.png',
    'sydsvenskan-16': 'sydsvenskan-16-2ed1d310445ea40c83c7f24e6a2b9efa79c89201.png',
    'sydsvenskan-32': 'sydsvenskan-32-989468b5d9c6e27437a68ef77e165392a798e01b.png',
    'sydsvenskan-64': 'sydsvenskan-64-0ce87e2a6e6608831b57e5b7ff1b46530bd9603b.png',
    'tv10': 'tv10-64-35320408aef350e48680cbbab05d4d0cf016002f.png',
    'tv10-16': 'tv10-16-bc4897855a5b6cacebb353c6e6131980fed60090.png',
    'tv10-32': 'tv10-32-8698e16929b9682dfd4edcd63db46b1199055632.png',
    'tv10-64': 'tv10-64-35320408aef350e48680cbbab05d4d0cf016002f.png',
    'tv12': 'tv12-64-38a3b2e72e573a840618516cdfec049197b4c030.png',
    'tv12-16': 'tv12-16-d4cb006d1702e3bdccdd707347c97e1cb24b1b33.png',
    'tv12-32': 'tv12-32-6da1af60a409c0b6993ac158bff79b3e2805cef6.png',
    'tv12-64': 'tv12-64-38a3b2e72e573a840618516cdfec049197b4c030.png',
    'tv3': 'tv3-64-8530fa9d8f34c111ad28e5aa16af34541c62a4a9.png',
    'tv3-16': 'tv3-16-3cdc49e9751a755a4e91fb490aa48ed5a7373ab9.png',
    'tv3-32': 'tv3-32-53419c7f15aedbf53159240aced7b42c8b6b3390.png',
    'tv3-64': 'tv3-64-8530fa9d8f34c111ad28e5aa16af34541c62a4a9.png',
    'tv3hd': 'tv3hd-64-5af4c75c78ebe85df7ebec0a28eac69317e276ac.png',
    'tv3hd-16': 'tv3hd-16-89a130820fba889575b8ebb2e33ece99d70f91a5.png',
    'tv3hd-32': 'tv3hd-32-f1cdb6f10b68bc402b76a5bf0bcdca2ebe91a565.png',
    'tv3hd-64': 'tv3hd-64-5af4c75c78ebe85df7ebec0a28eac69317e276ac.png',
    'tv4': 'tv4-64-be4a621ce1bc138474fc5f08b9818c0e72a86117.png',
    'tv4-16': 'tv4-16-da3cb15097ca051f1e3c1b5a5ae52a27d1f6547c.png',
    'tv4-32': 'tv4-32-f3ddcf9c867fe065e3b96f946d2863db3830d4e0.png',
    'tv4-64': 'tv4-64-be4a621ce1bc138474fc5f08b9818c0e72a86117.png',
    'tv4hd': 'tv4hd-64-03389fa2f691ac1aaa5dd415b3800d2083917d68.png',
    'tv4hd-16': 'tv4hd-16-4e08c2aa11f878ff21d22abe333bfb339596ab74.png',
    'tv4hd-32': 'tv4hd-32-aeefe52a778601d04cb46c19b6ac15d20ac12c1a.png',
    'tv4hd-64': 'tv4hd-64-03389fa2f691ac1aaa5dd415b3800d2083917d68.png',
    'tv4play': 'tv4play-64-d11a782f73c1c9c81155a680df97d9f1798c192b.png',
    'tv4play-16': 'tv4play-16-180464954ab21454d4885b3eabda4d943ff8076f.png',
    'tv4play-32': 'tv4play-32-714c931a97893c2da55bae7769fec2b75e50f2dc.png',
    'tv4play-64': 'tv4play-64-d11a782f73c1c9c81155a680df97d9f1798c192b.png',
    'tv4sport': 'tv4sport-64-7d31ee44e7a8d8b8119d6303c6be0a2eab523ba9.png',
    'tv4sport-16': 'tv4sport-16-b5cdee205bb42bb7851723549e05bcd4dcb354c8.png',
    'tv4sport-32': 'tv4sport-32-0822d8cf678de377b2d07766053c7d9257add1cd.png',
    'tv4sport-64': 'tv4sport-64-7d31ee44e7a8d8b8119d6303c6be0a2eab523ba9.png',
    'tv6': 'tv6-64-ed25573c2de5fe1b6d3d767c85f129407e939558.png',
    'tv6-16': 'tv6-16-a633920327e75eb83a6e67b1f8e32b7a7de73228.png',
    'tv6-32': 'tv6-32-f726455e6c658d881d52f73e892b93fa77935f6e.png',
    'tv6-64': 'tv6-64-ed25573c2de5fe1b6d3d767c85f129407e939558.png',
    'tv6hd': 'tv6hd-64-24a341bd9b35df2e63a5e267a6a726e30e2c055d.png',
    'tv6hd-16': 'tv6hd-16-32ad30adba15c9bc7713a02d0e3af1703ee6fafe.png',
    'tv6hd-32': 'tv6hd-32-bb5cd51e39d45d3caf43394c57cbe2b2b2b80e69.png',
    'tv6hd-64': 'tv6hd-64-24a341bd9b35df2e63a5e267a6a726e30e2c055d.png',
    'tv8': 'tv8-64-806877a9dd34852593cf2fbe1bc2e4c4b2b5b133.png',
    'tv8-16': 'tv8-16-0407101c4632ebcf0c4d4cd03fcd4354d9e70ea4.png',
    'tv8-32': 'tv8-32-b83a2086b1df49128d31e8ff0daaae045d543723.png',
    'tv8-64': 'tv8-64-806877a9dd34852593cf2fbe1bc2e4c4b2b5b133.png',
    'viaplay': 'viaplay-64-1b9031729763e6ffc3ed150ac491282375cc2bcd.png',
    'viaplay-16': 'viaplay-16-ef45684f0292d7374460809494fbad7745bd3c07.png',
    'viaplay-32': 'viaplay-32-93d0821328d0a25de8b35d03b7d1b34077afac8c.png',
    'viaplay-64': 'viaplay-64-1b9031729763e6ffc3ed150ac491282375cc2bcd.png',
    'viasatfotboll': 'viasatfotboll-64-bd7898ebd0513dec2d5dd9f96cb15b8697eb171f.png',
    'viasatfotboll-16': 'viasatfotboll-16-e85e006c250279f0b155d08005c04fbf2f2bbd5a.png',
    'viasatfotboll-32': 'viasatfotboll-32-68f357ccd80b2de71690ca4aae0fa30bc250f4b3.png',
    'viasatfotboll-64': 'viasatfotboll-64-bd7898ebd0513dec2d5dd9f96cb15b8697eb171f.png',
    'viasatfotbollhd': 'viasatfotbollhd-64-bce722b6601f2bb57abfd9029970cc816d089a71.png',
    'viasatfotbollhd-16': 'viasatfotbollhd-16-62bd9054f816fa7e02ed7b9c3dce36d1586107df.png',
    'viasatfotbollhd-32': 'viasatfotbollhd-32-9530020ec58f8beaae64d80f989784e5dbb455d7.png',
    'viasatfotbollhd-64': 'viasatfotbollhd-64-bce722b6601f2bb57abfd9029970cc816d089a71.png',
    'viasatgolf': 'viasatgolf-64-465b927d439ec98a23498bc9d448231da9fe75cb.png',
    'viasatgolf-16': 'viasatgolf-16-77b6f17437943244a76892d33b670d6bd2667f71.png',
    'viasatgolf-32': 'viasatgolf-32-28f9156470cec750b448b57148f7f7d0cc908845.png',
    'viasatgolf-64': 'viasatgolf-64-465b927d439ec98a23498bc9d448231da9fe75cb.png',
    'viasatgolfhd': 'viasatgolfhd-64-074ce9acb6a850e1eeb9c707c0188c5568d26120.png',
    'viasatgolfhd-16': 'viasatgolfhd-16-561d48666b9caeeadc0a4a4c7b63c24eb8fcef66.png',
    'viasatgolfhd-32': 'viasatgolfhd-32-3e9b318807feff189e7d73f1a58c54567adead58.png',
    'viasatgolfhd-64': 'viasatgolfhd-64-074ce9acb6a850e1eeb9c707c0188c5568d26120.png',
    'viasathockey': 'viasathockey-64-dab55e268e08ed740d0cbebe9780085e29cdf8ff.png',
    'viasathockey-16': 'viasathockey-16-8b9bf5a42320c1b7c458512976f91418cc18fad3.png',
    'viasathockey-32': 'viasathockey-32-8fa6aa067885fe8b1cf1785aff03679b11f3e71a.png',
    'viasathockey-64': 'viasathockey-64-dab55e268e08ed740d0cbebe9780085e29cdf8ff.png',
    'viasathockeyhd': 'viasathockeyhd-64-fc949c9efb045a2e44776ff7abac423f61bacf10.png',
    'viasathockeyhd-16': 'viasathockeyhd-16-1561ea959d67bf5a982b808e31d7b8fdf5ef79d5.png',
    'viasathockeyhd-32': 'viasathockeyhd-32-b7e7f7c0e95ea0aa82e8627f9e853a29a38e342d.png',
    'viasathockeyhd-64': 'viasathockeyhd-64-fc949c9efb045a2e44776ff7abac423f61bacf10.png',
    'viasatmotor': 'viasatmotor-64-a96a3393b31a83e8e8ab65e3f48d08445c21373e.png',
    'viasatmotor-16': 'viasatmotor-16-958151cb1794fe6d36da23244c53875189b251de.png',
    'viasatmotor-32': 'viasatmotor-32-5078827f9864794d9659e3b49f23061376c982f2.png',
    'viasatmotor-64': 'viasatmotor-64-a96a3393b31a83e8e8ab65e3f48d08445c21373e.png',
    'viasatmotorhd': 'viasatmotorhd-64-f62e8a7655a30935f80196aa51bb436b0f43be36.png',
    'viasatmotorhd-16': 'viasatmotorhd-16-67f4a21c24919b5cc2be505b1bf8d7dd82ac1141.png',
    'viasatmotorhd-32': 'viasatmotorhd-32-2c42dca896b41320af616586314f57a53b0a553f.png',
    'viasatmotorhd-64': 'viasatmotorhd-64-f62e8a7655a30935f80196aa51bb436b0f43be36.png',
    'viasatsport': 'viasatsport-64-7df6b995a8a8e31dd8629487973b4d5bf8bf54ab.png',
    'viasatsport-16': 'viasatsport-16-5ad38021a2edb0ff75aa6fb0dd5c4a01c245dc78.png',
    'viasatsport-32': 'viasatsport-32-96b9535dea6d1464be905660e4b8edd33f2c3a82.png',
    'viasatsport-64': 'viasatsport-64-7df6b995a8a8e31dd8629487973b4d5bf8bf54ab.png',
    'viasatsporthd': 'viasatsporthd-64-de087aec5a8dccda37efcd28010ffd541183925b.png',
    'viasatsporthd-16': 'viasatsporthd-16-dc19f23e1f4897d4b8045e04a7eafa084da4d477.png',
    'viasatsporthd-32': 'viasatsporthd-32-8ce7242d1cf01066f9aa0368bc2ba7dcf6951c25.png',
    'viasatsporthd-64': 'viasatsporthd-64-de087aec5a8dccda37efcd28010ffd541183925b.png',
    'viasatultra': 'viasatultra-64-5dd5925bf1238eb7ae4056ca7a9ac4ffd6ec4d73.png',
    'viasatultra-16': 'viasatultra-16-6df79debbcd73fa8832add596816462b86bed53d.png',
    'viasatultra-32': 'viasatultra-32-eb2b2c7a63bd4a2099bc386dce42b62e3973e602.png',
    'viasatultra-64': 'viasatultra-64-5dd5925bf1238eb7ae4056ca7a9ac4ffd6ec4d73.png'
  };

  svs.lb_ui.tv.getIMG = function (file, size) {
    var hashedStr,
        hashedStrRetina,
        cdn = config.options && config.options.cdn ? config.options.cdn : '',
        ret = {};

    if (hashedFiles[file] && size > 0) {
      hashedStr = hashedFiles[file + '-' + size] ? file + '-' + size : file;
      hashedStrRetina = hashedFiles[file + '-' + size * 2] ? file + '-' + size * 2 : file;
    }

    if (hashedFiles[hashedStr]) {
      ret = [cdn + path + hashedFiles[hashedStr], cdn + path + hashedFiles[hashedStrRetina]];
    }

    return ret;
  }; 


  if (isServerSide) {
    module.exports = svs.lb_ui.tv;
  }
})(svs);
 })(window);